import { requestAction } from '../actions/request';
import { clearAllDataAction, loadMockDataAction } from '../actions/data';
import { logoutAction } from '../actions/authentication';

const memoizedDescriptions = new Set();
export const CACHE_ERROR = 'already fetched';

const requestCache = () => next => (action) => {
  if (action.type === logoutAction.toString() || action.type === clearAllDataAction.toString()) {
    memoizedDescriptions.clear();
  } else if (action.type === loadMockDataAction.toString()
    && action.payload.requests && action.payload.requests.resolved) {
    Object.keys(action.payload.requests.resolved).forEach((k) => {
      memoizedDescriptions.add(action.payload.requests.resolved[k].description);
    });
  } else if (action.type === requestAction.toString() && action.meta && action.meta.description) {
    // let's see if we have fetched this already
    if (memoizedDescriptions.has(action.meta.description)) {
      const err = new Error(CACHE_ERROR);
      err.meta = action.meta;
      throw err;
    }
    memoizedDescriptions.add(action.meta.description);
  }
  return next(action);
};

export default requestCache;
